import { NgModule } from '@angular/core';

import {
  DxButtonModule,
  DxDataGridModule,
  DxFileUploaderModule,
  DxFormModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTabPanelModule,
  DxTextBoxModule,
  DxTooltipModule,
  DxTemplateModule,
  DxLoadPanelModule,
  DxLookupModule,
  DxToastModule,
  DxDropDownBoxModule,
  DxTabsModule,
  DxPopoverModule,
  DxButtonGroupModule,
  DxNumberBoxModule,
  DxRadioGroupModule,
  DxAccordionModule,
  DxTreeListModule,
  DxDateBoxModule,
  DxTextAreaModule,
  DxHtmlEditorModule,
  DxListModule,
  DxLoadIndicatorModule,
  DxBoxModule,
  DxAutocompleteModule,
  DxCheckBoxModule,
  DxMenuModule,
  DxCalendarModule,
  DxSwitchModule,
  DxTileViewModule,
  DxTagBoxModule
} from 'devextreme-angular';
import { DxiItemModule } from 'devextreme-angular/ui/nested';

const DEV_EXTREME_MODULES = [
  DxButtonModule,
  DxTabPanelModule,
  DxDataGridModule,
  DxTooltipModule,
  DxSelectBoxModule,
  DxFileUploaderModule,
  DxPopupModule,
  DxFormModule,
  DxTextBoxModule,
  DxTemplateModule,
  DxLoadPanelModule,
  DxToastModule,
  DxListModule,
  DxDropDownBoxModule,
  DxLookupModule,
  DxTabsModule,
  DxPopoverModule,
  DxButtonGroupModule,
  DxNumberBoxModule,
  DxRadioGroupModule,
  DxAccordionModule,
  DxTreeListModule,
  DxDateBoxModule,
  DxTextAreaModule,
  DxHtmlEditorModule,
  DxLoadIndicatorModule,
  DxBoxModule,
  DxAutocompleteModule,
  DxCheckBoxModule,
  DxMenuModule,
  DxCalendarModule,
  DxSwitchModule,
  DxTileViewModule,
  DxTagBoxModule,
  DxiItemModule
];

@NgModule({
  exports: DEV_EXTREME_MODULES,
})
export class LocalDevExtremeModule {}
